import { render, staticRenderFns } from "./VaccineGroupForm.vue?vue&type=template&id=3cd50c74&"
import script from "./VaccineGroupForm.vue?vue&type=script&lang=js&"
export * from "./VaccineGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports